import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  completed: true,
  step: 1,
  isBrandSkipped: false,
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    startTour: (state) => {
      ((state.completed = false), (state.step = 1));
    },
    nextStep: (s) => {
      s.step += 1;
    },
    completeTour: (s) => {
      s.completed = true;
    },
    setBrandSkipped: (s, action) => {
      s.isBrandSkipped = action.payload;
    },
  },
});

export const { startTour, nextStep, completeTour, setBrandSkipped } =
  tourSlice.actions;
export default tourSlice.reducer;
